import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import CooperativeDetails from "../components/cooperatives-list/CooperativeDetails";
import { useLoader } from "../context/LoaderContext";
import { useParams } from "react-router-dom";
import { fetchCooperativeDetails } from "../api/Cooperative";
import { dynamicFailed } from "../hooks/useToast";
import { ICooperativeDetails } from "../exports/interfaces";
import { useUser } from "../context/UserContext";

const CooperativesDetailsPage = () => {
  const { setLoading } = useLoader();
  const { id } = useParams();
  const [cooperative, setCooperative] = useState<ICooperativeDetails | null>(
    null,
  );
  const { user } = useUser();
  useEffect(() => {
    setLoading(true);
    if (!user) {
      return;
    }
    Promise.all([fetchCooperativeDetails(Number(id))])
      .then(([cooperativeData]) => {
        setCooperative(cooperativeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);

  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <CooperativeDetails cooperative={cooperative} />
      </div>
    </PageLayout>
  );
};

export default CooperativesDetailsPage;
